import useABTestValue from '@hooks/useABTestValue'

export type UseIsPianoDebugModeActiveType = () => boolean

const useIsPianoDebugModeActive: UseIsPianoDebugModeActiveType = () =>
  useABTestValue('pianoDebugMode') === 'active'

export default useIsPianoDebugModeActive
